import React from 'react';
import { Container, Typography, Box, Button, Card, CardContent } from '@mui/material';
import { LinkedIn } from '@mui/icons-material';
import PageTransition from '../components/animations/PageTransition';

const Contact: React.FC = () => {
    return (
        <PageTransition>
            <Container maxWidth="lg">
                <Box sx={{ py: 8, textAlign: 'center' }}>
                    <Typography variant="h2" gutterBottom sx={{ mb: 4 }}>
                        Contact Me
                    </Typography>
                    <Typography variant="h5" paragraph sx={{ mb: 6, color: 'text.secondary' }}>
                        Get in touch with me for opportunities and collaborations.
                    </Typography>
                    
                    <Card sx={{ 
                        maxWidth: 600, 
                        mx: 'auto',
                        background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(6, 182, 212, 0.1) 100%)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(59, 130, 246, 0.2)'
                    }}>
                        <CardContent sx={{ p: 4, textAlign: 'center' }}>
                            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
                                Let's Connect
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ 
                                mb: 4, 
                                color: 'text.secondary',
                                fontStyle: 'italic'
                            }}>
                                For privacy reasons, I don't expose my email or phone. The best way to reach me is LinkedIn.
                            </Typography>
                            <Button
                                variant="contained"
                                size="large"
                                startIcon={<LinkedIn />}
                                href="https://linkedin.com/in/johnfantell"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    background: 'linear-gradient(45deg, #0077B5, #00A0DC)',
                                    color: 'white',
                                    px: 4,
                                    py: 1.5,
                                    fontSize: '1.1rem',
                                    textTransform: 'none',
                                    '&:hover': {
                                        background: 'linear-gradient(45deg, #005885, #0077B5)',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 8px 25px rgba(0, 119, 181, 0.3)'
                                    },
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                Connect on LinkedIn
                            </Button>
                        </CardContent>
                    </Card>
                </Box>
            </Container>
        </PageTransition>
    );
};

export default Contact;
